// extracted by mini-css-extract-plugin
export default {"currency":"moneyCell-module__currency__EbWqj"};